import * as React from 'react';
import { Field, WrappedFieldInputProps } from 'redux-form';
import JRCFormFieldRender, { JRCWritableFormInputProps } from '../JRCFormFieldRender';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { useControls } from '../ReduxFormControls';

export interface JRCFormRangeProps extends JRCWritableFormInputProps {
    min: number;
    max: number;
    step: number;
}

const Slider = styled.input<{ percent: number } & React.ComponentPropsWithoutRef<'input'>>`
    cursor: pointer;
    --minRangePercent: ${(props) => props.percent}%;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 0.4rem;
    outline: none !important;
    background: transparent;
    border-radius: 0px !important;
    width: 100%;

    &::-webkit-slider-runnable-track,
    &::-moz-range-track,
    &::-ms-track {
        box-sizing: border-box;
        border: none;
        height: 4px;
        background: #0075fb;
        border-radius: 0px !important;
        height: 10px;
        background-color: transparent;
        background-image: linear-gradient(#0075fb, #0075fb), linear-gradient(#0075fb, #0075fb);
        background-size: var(--sx) 10px, calc(100% - var(--sx)) 4px;
        background-position: left center, right center;
        background-repeat: no-repeat;
    }

    &::focus {
        outline: none;
    }

    &::-webkit-slider-thumb,
    &::-moz-range-thumb {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        width: 14px;
        height: 14px;
        background: #0075fb;
        cursor: pointer;
        border: none;
        color: 1px solid #0075fb;
        border-radius: 50%;
    }

    background-image: linear-gradient(
        to right,
        #0075fb 0%,
        #0075fb var(--minRangePercent),
        silver var(--minRangePercent),
        silver 100%
    );
    &::-moz-range-progress {
        background: #0075fb;
        border-radius: 0px !important;
    }
`;
const renderInput = (props: JRCFormRangeProps, input: WrappedFieldInputProps) => {
    // Initialization of the input range and the redux-form
    if (input.value == '') {
        input.onChange(props.min + Math.floor((props.max - props.min) / props.step / 2) * props.step);
    }

    // variable used for custom styling
    const percent = ((input.value - props.min) / (props.max - props.min)) * 100;

    return <Slider id={props.name} type="range" percent={percent} {...props} {...input} />;
};

/**
 * Component used as a <input type="range"/>
 * RQ: the field may be required but is always set and hence cannot be "not set"
 * @param props JRCFormRangeProps
 * validation props: minValue, maxValue required
 * @returns JSX.Element
 * @deprecated use JRCInputRange instead
 */
export const JRCFormRangeField = (props: JRCFormRangeProps) => {
    const validate = useControls({
        intl: useIntl(),
        minValue: props.min,
        maxValue: props.max,
        required: props.required,
    });
    return (
        <Field
            component={JRCFormFieldRender}
            renderInputFct={(input: WrappedFieldInputProps) => renderInput(props, input)}
            validate={validate}
            htmlFor={props.name}
            {...props}
        />
    );
};
